import Api from '@sendsprint/api-types';
import {
  BeneficialOwnerFormData,
  BeneficialOwnerPeopleValue,
  BeneficialOwnerValues
} from '../components/beneficialOwnerStep';
import { getBeneficialOwnerSchema } from './getBeneficialOwnerSchema';

export const handleBeneficialOwnerData = (
  values: BeneficialOwnerFormData
  //   helpers: FormikHelpers<BeneficialOwnerFormData> | undefined
) => {
  const arrangedPeople: BeneficialOwnerPeopleValue[] = [];
  const peopleId = values.peopleId;
  const valueEntries = Object.entries(values);
  peopleId.forEach((item) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const itemObj: any = {};
    valueEntries.forEach((valueObj) => {
      const doesIdExist = valueObj[0].includes(item);
      if (doesIdExist) {
        const slicedValueKey = valueObj[0].split('-');
        itemObj[slicedValueKey[0]] = valueObj[1];
      }
    });

    arrangedPeople.push({ [item]: itemObj });
  });

  return arrangedPeople;
};

export const handleValidateBeneficialOwnerData = async (
  values: BeneficialOwnerFormData,
  country: Api.Model.CountryInitials
) => {
  const arrangedPeople = handleBeneficialOwnerData(values);
  let fullErrorObj: Record<string, string> | undefined = undefined;
  const fullTouchedObj: Record<string, boolean> = {};

  const validationPromises = arrangedPeople.map(async (person, index) => {
    const [personData] = Object.entries(person);
    const { errObj } = await handleCheckBeneficialOwnerData(personData, index, country);
    return errObj;
  });

  const errorObjects = await Promise.all(validationPromises);

  errorObjects.forEach((errObj) => {
    if (typeof errObj !== 'undefined') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const errObjKey = Object.keys(errObj as any);
      errObjKey.forEach((key) => {
        fullTouchedObj[key] = true;
      });
      fullErrorObj = { ...fullErrorObj, ...errObj };
    }
  });

  return { fullErrorObj, fullTouchedObj, arrangedPeople };
};

const handleCheckBeneficialOwnerData = async (
  personData: [string, BeneficialOwnerValues],
  index: number,
  country: Api.Model.CountryInitials
) => {
  const [key, value] = personData;
  try {
    await getBeneficialOwnerSchema(index, value, country).validate(value, { abortEarly: false });

    return { errObj: undefined };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    const errorArray = error.inner;
    const errObj: Record<string, string> = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errorArray.forEach((err: any) => {
      const fieldName = `${err.path}-${key}`;
      errObj[fieldName] = err.message;
    });

    return { errObj };
  }
};
